$(document).ready(function() {
  $('.table-responsive-stack').each(function(i) {
    var id = $(this).attr('id');
    $(this).find("th").each(function(i) {
      $('#' + id + ' td:nth-child(' + (i + 1) + ')').prepend('<span class="table-responsive-stack-thead">' + $(this).text() + ':</span> ');
      $('.table-responsive-stack-thead').hide();
    });
  });

  $('.table-responsive-stack').each(function(i) {
    var thCount = $(this).find("th").length;
    var rowGrow = 100 / thCount + '%';
    var id = $(this).attr('id');

    $(this).find("th").each(function(i) {
      th = $('#' + id + ' th:nth-child(' + (i + 1) + ')');
      flexBasis = th.attr("data-flex-basis");
      if (flexBasis) {
        th.css('flex-basis', flexBasis);
      } else {
        th.css('flex-basis', rowGrow);
      }
    });

    $(this).find("th").each(function(i) {
      th = $('#' + id + ' th:nth-child(' + (i + 1) + ')');
      flexBasis = th.attr("data-flex-basis");
      td = $('#' + id + ' td:nth-child(' + (i + 1) + ')');

        if (flexBasis) {
          td.css('flex-basis', flexBasis);
        } else {
          td.css('flex-basis', rowGrow);
        }
    });
  });

  function flexTable() {
    if ($(window).width() < 768) {
      $(".table-responsive-stack").each(function(i) {
        $(this).find(".table-responsive-stack-thead").show();
        $(this).find('thead').hide();
        $(this).find('tr').css('border', 'none');
      });
    } else {
      $(".table-responsive-stack").each(function(i) {
        $(this).find(".table-responsive-stack-thead").hide();
        $(this).find('thead').show();
        $(this).removeClass('table-bordered');
        $(this).find('tr').css('border', '');
      });
    }
  }

  flexTable();
  window.onresize = function(event) {
    flexTable();
  };
});
